// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__t77iU","ActionBox":"styles_ActionBox__4dZsY"};